import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NxAccordionModule} from '@allianz/ng-aquila/accordion';
import {NxActionModule} from '@allianz/ng-aquila/action';
import {NxAutocompleteModule} from '@allianz/ng-aquila/autocomplete';
import {NxAvatarModule} from '@allianz/ng-aquila/avatar';
import {NxBadgeModule} from '@allianz/ng-aquila/badge';
import {NxBreadcrumbModule} from '@allianz/ng-aquila/breadcrumb';
import {NxButtonModule} from '@allianz/ng-aquila/button';
import {NxCardModule} from '@allianz/ng-aquila/card';
import {NxCheckboxModule} from '@allianz/ng-aquila/checkbox';
import {NxCircleToggleModule} from '@allianz/ng-aquila/circle-toggle';
import {NxCodeInputModule} from '@allianz/ng-aquila/code-input';
import {NxComparisonTableModule} from '@allianz/ng-aquila/comparison-table';
import {NxContextMenuModule} from '@allianz/ng-aquila/context-menu';
import {NxCopytextModule} from '@allianz/ng-aquila/copytext';
import {NxDatefieldModule, NxNativeDateModule} from '@allianz/ng-aquila/datefield';
import {NxDropdownModule} from '@allianz/ng-aquila/dropdown';
import {NxDynamicTableModule} from '@allianz/ng-aquila/dynamic-table';
import {NxFileUploaderModule} from '@allianz/ng-aquila/file-uploader';
import {NxFooterModule} from '@allianz/ng-aquila/footer';
import {NxFormfieldModule} from '@allianz/ng-aquila/formfield';
import {NxGridModule} from '@allianz/ng-aquila/grid';
import {NxHeaderModule} from '@allianz/ng-aquila/header';
import {NxHeadlineModule} from '@allianz/ng-aquila/headline';
import {NxIconModule} from '@allianz/ng-aquila/icon';
import {NxImageModule} from '@allianz/ng-aquila/image';
import {NxIndicatorModule} from '@allianz/ng-aquila/indicator';
import {NxInputModule} from '@allianz/ng-aquila/input';
import {NxIsoDateModule} from '@allianz/ng-aquila/iso-date-adapter';
import {NxLinkModule} from '@allianz/ng-aquila/link';
import {NxListModule} from '@allianz/ng-aquila/list';
import {NxMaskModule} from '@allianz/ng-aquila/mask';
import {NxMenuModule} from '@allianz/ng-aquila/menu';
import {NxMessageModule} from '@allianz/ng-aquila/message';
import {NxModalModule} from '@allianz/ng-aquila/modal';
import {NxMomentDateModule} from '@allianz/ng-aquila/moment-date-adapter';
import {NxNaturalLanguageFormModule} from '@allianz/ng-aquila/natural-language-form';
import {NxNotificationPanelModule} from '@allianz/ng-aquila/notification-panel';
import {NxNumberStepperModule} from '@allianz/ng-aquila/number-stepper';
import {NxOverlayModule} from '@allianz/ng-aquila/overlay';
import {NxPageSearchModule} from '@allianz/ng-aquila/page-search';
import {NxPaginationModule} from '@allianz/ng-aquila/pagination';
import {NxPopoverModule} from '@allianz/ng-aquila/popover';
import {NxProgressStepperModule} from '@allianz/ng-aquila/progress-stepper';
import {NxProgressbarModule} from '@allianz/ng-aquila/progressbar';
import {NxRadioModule} from '@allianz/ng-aquila/radio-button';
import {NxRadioToggleModule} from '@allianz/ng-aquila/radio-toggle';
import {NxRatingModule} from '@allianz/ng-aquila/rating';
import {NxSidebarModule} from '@allianz/ng-aquila/sidebar';
import {NxSidepanelModule} from '@allianz/ng-aquila/sidepanel';
import {NxSliderModule} from '@allianz/ng-aquila/slider';
import {NxSmallStageModule} from '@allianz/ng-aquila/small-stage';
import {NxSpinnerModule} from '@allianz/ng-aquila/spinner';
import {NxSwitcherModule} from '@allianz/ng-aquila/switcher';
import {NxTableModule} from '@allianz/ng-aquila/table';
import {NxTabsModule} from '@allianz/ng-aquila/tabs';
import {NxTaglistModule} from '@allianz/ng-aquila/taglist';
import {NxTimefieldModule} from '@allianz/ng-aquila/timefield';
import {NxToolbarModule} from '@allianz/ng-aquila/toolbar';
import {NxTooltipModule} from '@allianz/ng-aquila/tooltip';
import {NxTreeModule} from '@allianz/ng-aquila/tree';
import {NxVideoModule} from '@allianz/ng-aquila/video';
import {AllianzIconModule} from '@allianz/ngx-brand-kit/icon';
import {NxPhoneInputModule} from '@allianz/ng-aquila/phone-input';



@NgModule({
  imports: [
    CommonModule,
    NxAccordionModule,
    NxActionModule,
    NxAutocompleteModule,
    NxAvatarModule,
    NxBadgeModule,
    NxBreadcrumbModule,
    NxButtonModule,
    NxCardModule,
    NxCheckboxModule,
    NxCircleToggleModule,
    NxPhoneInputModule,
    NxCodeInputModule,
    NxComparisonTableModule,
    NxContextMenuModule,
    NxCopytextModule,
    NxDatefieldModule,
    NxDropdownModule,
    NxDynamicTableModule,
    NxFileUploaderModule,
    NxFooterModule,
    NxFormfieldModule,
    NxGridModule,
    NxHeaderModule,
    NxHeadlineModule,
    NxIconModule,
    NxNativeDateModule,
    NxImageModule,
    NxIndicatorModule,
    NxInputModule,
    NxIsoDateModule,
    NxLinkModule,
    NxListModule,
    NxMaskModule,
    NxMenuModule,
    NxMessageModule,
    NxMomentDateModule,
    NxNaturalLanguageFormModule,
    NxNotificationPanelModule,
    NxNumberStepperModule,
    NxOverlayModule,
    NxPageSearchModule,
    NxPaginationModule,
    NxPopoverModule,
    NxProgressStepperModule,
    NxProgressbarModule,
    NxRadioModule,
    NxRadioToggleModule,
    NxRatingModule,
    NxSidebarModule,
    NxSidepanelModule,
    NxSliderModule,
    NxSmallStageModule,
    NxSpinnerModule,
    NxSwitcherModule,
    NxTableModule,
    NxTabsModule,
    NxTaglistModule,
    NxTimefieldModule,
    NxToolbarModule,
    NxTooltipModule,
    NxTreeModule,
    NxVideoModule,
    NxNativeDateModule,
    NxModalModule,
    AllianzIconModule
  ],
  exports: [
    NxAccordionModule,
    NxActionModule,
    NxAutocompleteModule,
    NxAvatarModule,
    NxBadgeModule,
    NxBreadcrumbModule,
    NxButtonModule,
    NxCardModule,
    NxCheckboxModule,
    NxCircleToggleModule,
    NxPhoneInputModule,
    NxCodeInputModule,
    NxComparisonTableModule,
    NxContextMenuModule,
    NxCopytextModule,
    NxDatefieldModule,
    NxDropdownModule,
    NxDynamicTableModule,
    NxFileUploaderModule,
    NxFooterModule,
    NxFormfieldModule,
    NxGridModule,
    NxHeaderModule,
    NxHeadlineModule,
    NxIconModule,
    NxNativeDateModule,
    NxImageModule,
    NxIndicatorModule,
    NxInputModule,
    NxIsoDateModule,
    NxLinkModule,
    NxListModule,
    NxMaskModule,
    NxMenuModule,
    NxMessageModule,
    NxMomentDateModule,
    NxNaturalLanguageFormModule,
    NxNotificationPanelModule,
    NxNumberStepperModule,
    NxOverlayModule,
    NxPageSearchModule,
    NxPaginationModule,
    NxPopoverModule,
    NxProgressStepperModule,
    NxProgressbarModule,
    NxRadioModule,
    NxRadioToggleModule,
    NxRatingModule,
    NxSidebarModule,
    NxSidepanelModule,
    NxSliderModule,
    NxSmallStageModule,
    NxSpinnerModule,
    NxSwitcherModule,
    NxTableModule,
    NxTabsModule,
    NxTaglistModule,
    NxTimefieldModule,
    NxToolbarModule,
    NxTooltipModule,
    NxTreeModule,
    NxVideoModule,
    NxNativeDateModule,
    NxModalModule,
    AllianzIconModule

  ]
})
export class NdbxModule {
}
